import axios from '../../node_modules/axios/dist/axios.min.js'
import config from './config.js'

export default {

  list(start,count) {
    return axios.get(config.baseUrl + 'rest/passwords/data?start=' + encodeURIComponent(start) + '&count=' + encodeURIComponent(count));
  },

  update(entry) {
    return axios.post(config.baseUrl + 'rest/passwords/data',entry);
  },

  delete(id) {
    return axios.delete(config.baseUrl + 'rest/passwords/data/' + encodeURIComponent(id));
  }

}
